import { render, staticRenderFns } from "./crowd-control.vue?vue&type=template&id=5d9626d0&"
import script from "./crowd-control.vue?vue&type=script&lang=ts&"
export * from "./crowd-control.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-control.vue?vue&type=style&index=0&id=5d9626d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports